import Routes from 'routes/Routes';
import { initDarkMode } from 'data/services/darkMode';
import { initApiUrlFromLocalStorage } from 'data/services/apiConstants';
import { initThirdPartyScripts } from 'utils/thirdPartyTags';

import './App.css';
import './Theme.css';
// newDesignPreflight (a scoped, minimal stand-in for Tailwind's own disabled
// Preflight - see that file's header comment) must load BEFORE tailwind.css,
// the same way Tailwind's own base layer precedes its utilities layer.
// Reversed, an equal-specificity utility class (e.g. tw-bg-surface-layer-01)
// loses ties to this file's base rules instead of winning them.
import './styles/newDesignPreflight.css';
import './styles/tailwind.css';
import './styles/v3Scope.css';

function App() {
	initDarkMode();
	initApiUrlFromLocalStorage();
	initThirdPartyScripts();
	return <Routes />;
}

export default App;
